/**
 * Vue Customizer Canvas
 *
 * Drawing logic for the live product label customizer. The personalized
 * collection grid (assets/personalized-grid.js) calls window.updateCanvas from
 * this file directly to render its preview cards without mounting Vue, so
 * changes here affect both the live customizer and the grid previews.
 */
// Guard: only run once to support multiple sections
if (window.__vueCanvasLoaded) {
  // Already loaded, skip
} else {
window.__vueCanvasLoaded = true;

// Global constants
var CANVAS_WIDTH = 2000;
var CANVAS_HEIGHT = 2000;
var DEBUG_MODE = false;
var orbitIconImages = {};
if (window.location.hostname === '127.0.0.1') {
  DEBUG_MODE = true;
}

String.prototype.hashCode = function() {
	var hash = 0,
		i, chr;
	if (this.length === 0) return hash;
	for (i = 0; i < this.length; i++) {
		chr = this.charCodeAt(i);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
}

const canvasLog = function (message, trace = false) {
	if (DEBUG_MODE) {
		console.log('%c '+message, 'background: purple; color: white');
		if (trace) {
			console.trace();
		}
	}
}

CanvasRenderingContext2D.prototype.drawRoundedRect = function (x, y, width, height, radius, color) {
	if (width < 2 * radius)
		radius = width / 2;

	if (height < 2 * radius)
		radius = height / 2;
	this.fillStyle = color;
	this.beginPath();
	this.moveTo(x + radius, y);
	this.arcTo(x + width, y, x + width, y + height, radius);
	this.arcTo(x + width, y + height, x, y + height, radius);
	this.arcTo(x, y + height, x, y, radius);
	this.arcTo(x, y, x + width, y, radius);
	this.closePath();
	this.fill();
}

// Icon ShoePals: share of silhouette samples the die may cut, and how many 1 % shrink steps to try.
const SHOEPAL_CUT_TOLERANCE = 0.01;
const SHOEPAL_FIT_STEPS = 15;

class BaseArea {
	fontFamily;
	type;
	size;
	duoAngle = 30;
	duoStart = 50;
	duoSplit = 17; // percent
	duoSplitWidth = 2; // percent
	duoSplitColor = "#ffffff";

	constructor(x, y, width, height, radius, maxTextWidth, maxTextHeight, type=null) {
		this.x = x;
		this.y = y;
		this.width = width;
		this.height = height;
		this.radius = radius;
		this.maxTextWidth = maxTextWidth;
		this.maxTextHeight = maxTextHeight;
		this.maxTextHeightHalf = this.maxTextHeight / 2;
		
		if (this.type != 'bagtag' || (this.type=='photo' && this.size.includes('BagTag'))) {
			this.textX = x + (this.width - this.maxTextWidth)/2;
			this.textY = y + (this.height - this.maxTextHeight)/2;
		}

		this.iconWidth = 184;
		this.iconHeight = 164;
		this.iconX = this.x + this.width/2 - this.iconWidth/2;
		this.iconY = this.y + (this.height - this.iconHeight)/2;
		this.hasIcon = false;
		this.iconPosition = 'left';
		this.type = type;
		//this.textX = x + (width - this.maxTextWidth) / 2;
		//this.textY = y;
	}

	drawBGColor(ctx) {
		if (this.backgroundColor) {
			if (this.backgroundColorAlt) {
				//let gradient = ctx.createLinearGradient(this.x, this.y, this.x+this.width+this.duoAdjustmentX, this.y+this.height+this.duoAdjustmentY);

				let angle = + this.duoAngle / 180 * Math.PI;

				let halfWidth = this.width / 2;
				let halfHeight = this.height / 2;
				let length = Math.sqrt(halfWidth * halfWidth + halfHeight * halfHeight);
				let centerX = this.x + halfWidth;
				let centerY = this.y + halfHeight;
				let deltaX = length * Math.cos(angle);
				let deltaY = length * Math.sin(angle);

				let gradient = ctx.createLinearGradient(
					centerX - deltaX,
					centerY - deltaY,
					centerX + deltaX,
					centerY + deltaY
				);

				let splitAt = this.duoSplit/100;
				let splitUntil = (this.duoSplit+this.duoSplitWidth)/100;
				gradient.addColorStop(0, this.backgroundColor);
				gradient.addColorStop(splitAt, this.backgroundColor);
				gradient.addColorStop(splitAt, this.duoSplitColor);
				gradient.addColorStop(splitUntil, this.duoSplitColor);
				gradient.addColorStop(splitUntil, this.backgroundColorAlt);
				gradient.addColorStop(1, this.backgroundColorAlt);
				ctx.fillStyle = gradient;
			} else {
				ctx.fillStyle = this.backgroundColor || "#ffffff";
			}
			ctx.shadowColor = "rgba(0,0,0,.1)";
			ctx.shadowBlur = 10;
			ctx.shadowOffsetX = 4;
			ctx.shadowOffsetY = 4;
			ctx.drawRoundedRect(this.x, this.y, this.width, this.height, this.radius);
			ctx.fill();
		}
	}

	/** Same line rules as drawText: default for an empty Line_1, mini sizes are one line. */
	collectLines(texts, label) {
		const lines = [];
		for (let i = 1; i <= 4; i++) {
			const text = texts['Line_' + i];
			if (text) {
				lines.push(text);
			} else if (i === 1) {
				lines.push(label.defaults.Line_1);
			}
			if (this.size == 'mini' || this.size == 'miniTagPals') {
				break;
			}
		}
		return lines;
	}

	/**
	 * Place the icon the way the print templates do: the icon's ink (its opaque
	 * pixels, not the PNG's padded frame) contain-fits the template icon box,
	 * centred; 'fill' stretches the whole image to the box (allergy panel). The
	 * render loop draws this.iconImage at iconX/iconY/iconWidth/iconHeight, clipped
	 * to the die shape, after drawText.
	 */
	placeIconFromSpec(iconFraction, iconFit) {
		const fit = window.LabelTextFit;
		const box = fit.boxFromSpec(iconFraction, this);
		const img = this.iconImage;
		const image = {
			width: (img && img.naturalWidth) || box.width,
			height: (img && img.naturalHeight) || box.height,
		};
		const ink = fit.imageInkBounds(img) || { x: 0, y: 0, width: image.width, height: image.height };
		const rect = fit.iconDrawRect(image, ink, box, iconFit);
		this.iconX = rect.x;
		this.iconY = rect.y;
		this.iconWidth = rect.width;
		this.iconHeight = rect.height;
		this.iconClip = true;
	}

	/**
	 * Print-accurate path: fit the whole block's ink into the template text box.
	 * this.printTemplate (set per render from the product code) carries the exact
	 * boxes for the print product; without one, spec.labels[size] boxes are used.
	 */
	drawTextPrint(ctx, texts, label, spec) {
		const fit = window.LabelTextFit;
		const template = this.printTemplate;
		const lines = this.collectLines(texts, label);
		const variant = this.hasIcon ? 'icon' : 'plain';
		const textFraction = template ? template.textBox : (spec.textBox[variant] || spec.textBox.plain);
		const iconFraction = (template && template.iconBox) || spec.iconBox;
		const usesIconBox = this.type === 'icon' && this.hasIcon && !!iconFraction;
		if (usesIconBox) {
			this.placeIconFromSpec(iconFraction, template && template.iconFit);
		}
		const box = fit.boxFromSpec(textFraction, this);
		const anchorX = template ? this.x + template.anchorX * this.width : undefined;
		const leading = fit.leadingFor(window.LabelPrintSpec, this.fontName, template ? template.name : null);
		const pxPerPt = this.width / spec.die.w / 72;
		const metrics = fit.measureLines(ctx, this.fontFamily, lines);
		const ink = fit.layoutInk(metrics, leading);
		const fontSize = fit.fitScale(ink, box, fit.capsFor(window.LabelPrintSpec, this.fontName, pxPerPt));
		if (!(fontSize > 0)) {
			return;
		}
		let placed = fit.placeBlock(ink, fontSize, box, anchorX);
		if (template && template.frameSize) {
			// Print moves this product's text vertically, then resizes it around the frame.
			const drift = fit.resizeDrift(ink, fit.measureFont(ctx, this.fontFamily), leading, lines.length, template.frameSize * pxPerPt, fontSize);
			placed = fit.shiftPlaced(placed, 0, drift.dy);
		}

		ctx.font = `${fontSize}px ${this.fontFamily}`;
		ctx.textAlign = 'center';
		ctx.textBaseline = 'alphabetic';
		ctx.fillStyle = this.textColor;
		for (const [i, line] of lines.entries()) {
			ctx.fillText(line, placed.x, placed.baselines[i]);
		}

		// Inspectable from the browser (verification + calibration); cheap to keep on.
		// Cleared at the start of every updateCanvas pass; keyed by the spec entry so
		// allergy (size 'large', printSpecSize 'allergy') does not collide with large.
		window.__labelFits = window.__labelFits || {};
		window.__labelFits[`${this.printSpecSize || this.size}:${this.index}`] = {
			size: this.size,
			index: this.index,
			template: template ? template.name : null,
			templateSet: template ? template.set : null,
			anchorX,
			lines,
			fontName: this.fontName,
			fontSizePx: fontSize,
			fontSizePt: fontSize / pxPerPt,
			leading,
			box,
			inkBox: placed.inkBox,
			iconBox: usesIconBox ? fit.boxFromSpec(iconFraction, this) : null,
			icon: usesIconBox ? { x: this.iconX, y: this.iconY, width: this.iconWidth, height: this.iconHeight } : null,
		};

		if (DEBUG_MODE) {
			ctx.save();
			ctx.lineWidth = 2;
			ctx.strokeStyle = 'red';
			ctx.strokeRect(box.x, box.y, box.width, box.height);
			ctx.strokeStyle = 'blue';
			ctx.strokeRect(placed.inkBox.x, placed.inkBox.y, placed.inkBox.width, placed.inkBox.height);
			if (iconFraction) {
				const iconBox = fit.boxFromSpec(iconFraction, this);
				ctx.strokeStyle = 'green';
				ctx.strokeRect(iconBox.x, iconBox.y, iconBox.width, iconBox.height);
			}
			ctx.restore();
		}
	}

	/**
	 * Bag tag names like print (LabelPrintSpec.bagTags): circle tags on the back disc,
	 * centred on the template text frame; rectangle tags on the front, centred
	 * vertically on TextBB and horizontally on the frame. Geometry comes from the
	 * tag found in the artwork. Returns false while the artwork is not loaded.
	 */
	drawBagTagTextPrint(ctx, texts, label) {
		const fit = window.LabelTextFit;
		const tags = window.LabelPrintSpec.bagTags;
		const img = this.backgroundImage;
		let box;
		let anchorX;
		let pxPerIn;
		let frameSize;
		const isCircle = this.size === 'circleBagTags';
		if (isCircle) {
			const disc = fit.circleBagTagBackDisc(img);
			if (!disc) {
				return false;
			}
			const scaleX = this.width / img.naturalWidth;
			const scaleY = this.height / img.naturalHeight;
			pxPerIn = disc.d * scaleX / tags.circle.diameter;
			const product = tags.circle.combos[this.printProductCode] || this.printProductCode;
			const centre = tags.circle.centre[product] || tags.circle.centre.circlebagtags;
			const x = this.x + disc.cx * scaleX + centre.x * pxPerIn;
			const y = this.y + disc.cy * scaleY + centre.y * pxPerIn;
			const width = tags.circle.textBox.w * tags.circle.fill * pxPerIn;
			const height = tags.circle.textBox.h * tags.circle.fill * pxPerIn;
			box = { x: x - width / 2, y: y - height / 2, width, height };
			anchorX = x;
			frameSize = tags.circle.frameSize;
		} else {
			const front = fit.rectangleBagTagFront(img);
			if (!front) {
				return false;
			}
			const scaleX = this.width / img.naturalWidth;
			const scaleY = this.height / img.naturalHeight;
			const tag = { x: this.x + front.x * scaleX, y: this.y + front.y * scaleY, width: front.width * scaleX, height: front.height * scaleY };
			box = fit.boxFromSpec(tags.rectangle.textBox, tag);
			anchorX = tag.x + tags.rectangle.anchorX * tag.width;
			pxPerIn = tag.width / tags.rectangle.tag.w;
			frameSize = tags.rectangle.frameSize;
		}
		const lines = this.collectLines(texts, label);
		const leading = window.LabelPrintSpec.leading.default;
		const ink = fit.layoutInk(fit.measureLines(ctx, this.fontFamily, lines), leading);
		const fontSize = fit.fitScale(ink, box);
		if (!(fontSize > 0)) {
			return true;
		}
		// Print moves the text (circle: ink onto the frame centre, both axes;
		// rectangle: vertically onto TextBB), then resizes it around the frame.
		const inkCentreX = isCircle ? fontSize * (ink.right - ink.left) / 2 : 0;
		const drift = fit.resizeDrift(ink, fit.measureFont(ctx, this.fontFamily), leading, lines.length, frameSize * pxPerIn / 72, fontSize);
		const placed = fit.shiftPlaced(fit.placeBlock(ink, fontSize, box, anchorX - inkCentreX), isCircle ? drift.dx : 0, drift.dy);
		ctx.font = `${fontSize}px ${this.fontFamily}`;
		ctx.textAlign = 'center';
		ctx.textBaseline = 'alphabetic';
		ctx.fillStyle = this.textColor;
		for (const [i, line] of lines.entries()) {
			ctx.fillText(line, placed.x, placed.baselines[i]);
		}
		window.__labelFits = window.__labelFits || {};
		window.__labelFits[`${this.size}:${this.index}`] = {
			size: this.size,
			index: this.index,
			template: this.printProductCode,
			lines,
			fontSizePx: fontSize,
			fontSizePt: fontSize / (pxPerIn / 72),
			leading,
			box,
			inkBox: placed.inkBox,
		};
		return true;
	}

	drawText(ctx, texts, label, rotate= 0) {
		const printSpec = window.LabelPrintSpec && window.LabelTextFit && window.LabelPrintSpec.labels[this.printSpecSize || this.size];
		if (printSpec) {
			return this.drawTextPrint(ctx, texts, label, printSpec);
		}
		const isBagTag = this.type === 'bagtag' && (this.size === 'circleBagTags' || this.size === 'rectangleBagTags');
		if (isBagTag && window.LabelPrintSpec && window.LabelTextFit && this.drawBagTagTextPrint(ctx, texts, label)) {
			return;
		}
		let maxHeight,
			fontSize = 9999,
			fsTemp,
			maxTextWidth = this.maxTextWidth,
			maxTextHeight = this.maxTextHeight,
			textX = this.textX + maxTextWidth / 2,
			textY,
			adjustTextX= 0,
			adjustTextY= 0,
			lines=[];

		if (this.hasIcon) {
			switch (this.iconPosition) {
				case 'left':
					maxTextWidth = this.maxTextWidth - this.iconWidth;
					adjustTextX = this.iconWidth/2;
					this.iconX = this.x + (this.height - this.iconHeight)/2;
					break;
				case 'top':
					adjustTextY = this.iconHeight/2;
					this.iconY = this.y + 15; //added 15px on top of the icon
					break;
			}
		}

		for (let i=1; i<=4; i++) {
			if (!texts['Line_'+i]) {
				if (i===1) {
					lines.push(label.defaults.Line_1);
				} else {
					continue;
				}
			} else {
				lines.push(texts['Line_'+i]);
			}
			maxHeight = this.maxTextHeight / lines.length;
			let tempText = texts['Line_'+i];
			if (!tempText) {
				tempText = label.defaults.Line_1;
			}
			fsTemp = this.calculateOptimalFontSize(ctx, tempText, maxTextWidth, maxHeight);
			if (fsTemp < fontSize) {
				fontSize = fsTemp;
			}
			// Mini and Mini TagPals labels are physically one-line only — never
			// draw a second line even if texts carries one (e.g. from the
			// personalized-grid localStorage bridge).
			if (this.size == 'mini' || this.size == 'miniTagPals') {
				break;
			}
		}

		ctx.font = `${fontSize}px ${this.fontFamily}`;

		if (['shoepals', 'shoepals_icon'].indexOf(this.type) >= 0 && this.rotate) {
			const centerX = this.textX + this.width / 2;
			const centerY = this.textY + this.height / 2;
		}

		for (let i=0; i<lines.length; i++) {
			if (this.mirrored) {
				textY = this.textMY + maxHeight/2 - fontSize * 0.2 + fontSize * 0.1 + maxHeight*i;
				textX = this.textMX + maxTextWidth / 2;
			} else {
				if (['shoepals', 'shoepals_icon'].indexOf(this.type) >= 0) {
					textX = this.textX;
				} else if (this.size == 'circleBagTags') {
					textX = this.x + maxTextWidth/2 + (this.width - maxTextWidth)/2 + maxTextWidth*0.45;
				} else if (this.size == 'rectangleBagTags') {
					textX = this.x + maxTextWidth/2 + (this.width - maxTextWidth)/2 + 35;
				} else {
					textX = this.x + maxTextWidth/2 + (this.width - maxTextWidth)/2;
				}
				if (this.iconPosition == 'left' && this.hasIcon) {
					textX += adjustTextX;
				}
				textY = this.textY + this.maxTextHeight/lines.length/2 + this.maxTextHeight/lines.length*i;
				if (this.hasIcon && this.iconPosition == 'top') {
					textY += adjustTextY;
				}
			}
			ctx.textAlign = "center";
			ctx.textBaseline = this.baseline;
			ctx.fillStyle = this.textColor + 'D8';
			ctx.fillText(lines[i], textX, textY);
			if (DEBUG_MODE) {
				ctx.strokeStyle = "red"; // temporary border around the text
				ctx.lineWidth = 3; // temporary border around the text
				ctx.strokeRect(textX-maxTextWidth/2, textY-this.maxTextHeight/2, maxTextWidth, this.maxTextHeight); // temporary border around the text
			}
		}
		if (texts['Line_Back'] && label.has_back) {
			let fs = this.calculateOptimalFontSize(ctx, texts['Line_Back'], maxTextWidth, this.maxTextHeightBack);
			ctx.font = `${fs}px ${this.fontFamily}`;
			ctx.textAlign = "center";
			ctx.textBaseline = this.baseline;
			ctx.fillStyle = this.textColorBack + 'D8';
			ctx.fillText(texts['Line_Back'], textX, this.textBackY);
			if (DEBUG_MODE) {
				ctx.strokeStyle = "red"; // temporary border around the text
				ctx.lineWidth = 3; // temporary border around the text
				ctx.strokeRect(textX-maxTextWidth/2, this.textBackY-this.maxTextHeightBack/2, maxTextWidth, this.maxTextHeightBack); // temporary border around the text
			}
		}
	}

	drawLetter(ctx, letter, label) {
		if (label.type == 'orbit') {
			return;
		}

		if (letter == '' && label.type == 'monogram') {
			letter = label.defaults.Letter;
		}

		let textX = this.x + (this.height - this.iconHeight)/2 + this.iconWidth/2;
		let textY = this.y + (this.height/2);
		if (this.iconPosition == 'top') {
			textY = this.y + (this.width - this.maxTextWidth);
		}

		let fontSize = this.iconHeight;
		ctx.font = `${fontSize}px ${this.fontFamilyMono}`;
		ctx.textBaseline = this.monogram_baseline;

		ctx.textAlign = "center";
		ctx.fillStyle = this.textColor + 'D8';
		ctx.fillText(letter, textX, textY);

		if (DEBUG_MODE) {
			ctx.strokeStyle = "red"; // temporary border around the text
			ctx.lineWidth = 3; // temporary border around the text
			ctx.strokeRect(textX-this.iconWidth/2, textY-this.iconHeight/2, this.iconWidth, this.iconHeight); // temporary border around the text
		}
	}

	getOrbitIconFillColor() {
		const textColor = this.textColor || '#000000';
		if (textColor.toLowerCase() === '#ffffff') {
			return textColor;
		}

		const hex = textColor.replace('#', '');
		if (!/^[0-9a-f]{6}$/i.test(hex)) {
			return textColor;
		}

		const amount = 0.93;
		const r = Math.max(0, Math.round(parseInt(hex.slice(0, 2), 16) * amount));
		const g = Math.max(0, Math.round(parseInt(hex.slice(2, 4), 16) * amount));
		const b = Math.max(0, Math.round(parseInt(hex.slice(4, 6), 16) * amount));
		return `#${[r, g, b].map((value) => value.toString(16).padStart(2, '0')).join('')}`;
	}

	drawOrbitIcon(ctx, iconImage, label) {
		if (!iconImage || !iconImage.complete || !iconImage.naturalWidth) {
			return;
		}

		if (label.type == 'orbit') {
			this.addBlur(ctx);
		}

		let iconX = this.x + (this.height - this.iconHeight)/2 - 30;
		let iconY = this.y + (this.height/2) - 10 - (this.iconHeight/2);
		if (this.iconPosition == 'top') {
			iconY = this.y + (this.width - this.maxTextWidth) - (this.iconHeight/2);
		}

		let tempCanvas = document.createElement('canvas');
		let tempCtx = tempCanvas.getContext('2d');
		tempCanvas.width = this.iconWidth;
		tempCanvas.height = this.iconHeight;

		let sourceWidth = iconImage.naturalWidth || iconImage.width || this.iconWidth;
		let sourceHeight = iconImage.naturalHeight || iconImage.height || this.iconHeight;
		let scale = Math.min(this.iconWidth / sourceWidth, this.iconHeight / sourceHeight);
		let drawWidth = sourceWidth * scale;
		let drawHeight = sourceHeight * scale;
		let drawX = (this.iconWidth - drawWidth) / 2;
		let drawY = (this.iconHeight - drawHeight) / 2;

		tempCtx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
		tempCtx.drawImage(iconImage, drawX, drawY, drawWidth, drawHeight);
		tempCtx.globalCompositeOperation = "source-in";
		tempCtx.fillStyle = this.getOrbitIconFillColor();
		tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
		tempCtx.globalCompositeOperation = "source-over";

		ctx.save();
		const useDarkIconShadow = this.textColor === '#ffffff';
		ctx.shadowBlur = useDarkIconShadow ? 5 : 2;
		ctx.shadowColor = useDarkIconShadow ? 'rgba(0, 0, 0, .45)' : 'rgba(255, 255, 255, .7)';
		ctx.shadowOffsetX = useDarkIconShadow ? 2 : 1;
		ctx.shadowOffsetY = 1;
		ctx.drawImage(tempCanvas, iconX, iconY, this.iconWidth, this.iconHeight);
		ctx.restore();

		if (label.type == 'orbit') {
			this.removeBlur(ctx);
		}

		if (DEBUG_MODE) {
			ctx.strokeStyle = "red"; // temporary border around the icon
			ctx.lineWidth = 3; // temporary border around the icon
			ctx.strokeRect(iconX, iconY, this.iconWidth, this.iconHeight); // temporary border around the icon
		}
	}

	drawTextOrbit(ctx, texts, label) {
		let maxHeight, maxHeightL1, maxHeightL2,
			fontSize = 9999,
			fs1, fs2,
			maxTextWidth = this.maxTextWidth,
			textX, // = this.textX + maxTextWidth / 2,
			textY,
			adjustTextX = 0,
			adjustTextY = 0,
			lines=[];

		if (this.hasIcon) {
			switch (this.iconPosition) {
				case 'left':
					maxTextWidth = this.maxTextWidth - this.iconWidth;
					adjustTextX = this.iconWidth;
					this.iconX = this.x + (this.height - this.iconHeight)/2;
					break;
				case 'top':
					adjustTextY = this.iconHeight/2;
					this.iconY = this.y + 15; //added 15px on top of the icon
					break;
			}
		}

		for (let i=1; i<=2; i++) {
			if (!texts['Line_'+i]) {
				if (i===1) {
					lines.push(label.defaults.Line_1);
				} else {
					continue;
				}
			} else {
				lines.push(texts['Line_'+i]);
			}
		}

		this.addBlur(ctx);

		if (lines[1]) {
			maxHeightL1 = this.maxTextHeight * 0.9;
			maxHeightL2 = this.maxTextHeight * 0.4;
			fs1 = this.calculateOptimalFontSize(ctx, lines[0], maxTextWidth, maxHeightL1);
			fs2 = this.calculateOptimalFontSize(ctx, lines[1], maxTextWidth, maxHeightL2);
			if (fs2 > fs1*0.65) {
				fs2 = fs1*0.65;
			}
		} else {
			let adjustment = this.fontFamily === 'Arial' ? 0 : 22;
			maxHeightL1 = this.maxTextHeight;
			fs1 = this.calculateOptimalFontSize(ctx, lines[0], maxTextWidth, maxHeightL1);
		}

		textX = this.textX + maxTextWidth/2 + adjustTextX;
		textY = this.textY + maxHeightL1/2 + adjustTextY;

		ctx.font = `${fs1}px ${this.fontFamily}`;

		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		ctx.fillStyle = this.textColor + 'D8';
		ctx.fillText(lines[0], textX, textY);
		/*ctx.arc(textX, textY, 50, 0, 2 * Math.PI);
		ctx.lineWidth = 4;
		ctx.strokeStyle = "green";
		ctx.stroke();*/
		if (DEBUG_MODE) {
			ctx.strokeStyle = "blue"; // temporary border around the text
			ctx.lineWidth = 3; // temporary border around the text
			ctx.strokeRect(textX - maxTextWidth/2, textY - maxHeightL1/2, maxTextWidth, maxHeightL1); // temporary border around the text
		}

		if (lines[1]) {
			ctx.font = `${fs2}px ${this.fontFamily}`;
			textY = this.textY + maxHeightL1;
			ctx.textAlign = "center";
			ctx.textBaseline = "middle";
			ctx.fillStyle = this.textColor + 'D8';
			ctx.fillText(lines[1], textX, textY);
			if (DEBUG_MODE) {
				ctx.strokeStyle = "purple"; // temporary border around the text
				ctx.lineWidth = 3; // temporary border around the text
				ctx.strokeRect(textX - maxTextWidth/2, textY - maxHeightL2/2, maxTextWidth, maxHeightL2); // temporary border around the text
			}
		}

		this.removeBlur(ctx);
	}

	drawShoePalIcon(ctx) {
		if (this.shoepals_icon instanceof HTMLImageElement && (!this.shoepals_icon.complete || !this.shoepals_icon.naturalWidth)) return;
		let gap = this.gap;
		let border = this.iconHeight*0.02;
		//let img = this.shoepals_icon;

		// Get the temporary canvas and context
		let tempCanvas = document.createElement('canvas');
		let tempCtx = tempCanvas.getContext('2d');
		tempCanvas.width = this.shoepals_icon.width + border*2;
		tempCanvas.height = this.shoepals_icon.height + border*2;
		tempCtx.fillStyle = "transparent";
		tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
		tempCtx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);

		var dArr = [-1,-1, 0,-1, 1,-1, -1,0, 1,0, -1,1, 0,1, 1,1], // offset array
		//var dArr = [-1,-1, 0, -1, -1], // offset array
			s = border,  // thickness scale
			i = 0,  // iterator
			x = 10,  // final position
			y = 10;

		// draw images at offsets from the array scaled by s
		for(; i < dArr.length; i += 2)
			tempCtx.drawImage(this.shoepals_icon, 0, 0, this.shoepals_icon.width, this.shoepals_icon.height, x + dArr[i]*s, y + dArr[i+1]*s, this.shoepals_icon.width, this.shoepals_icon.height);

		// fill with color
		tempCtx.globalCompositeOperation = "source-in";
		tempCtx.fillStyle = this.backgroundColor || "rgba(255, 255, 255, 0)"; // Ensure the background is transparent
		tempCtx.fillRect(0,0, tempCanvas.width, tempCanvas.height);

		// draw original image in normal mode
		tempCtx.globalCompositeOperation = "source-over";
		tempCtx.drawImage(this.shoepals_icon, 0, 0, this.shoepals_icon.width, this.shoepals_icon.height, border, border, this.shoepals_icon.width, this.shoepals_icon.height);

		/*ctx.fillStyle = "red";
		ctx.fillRect(this.x, this.y, this.width, this.height);*/

		// Draw the rounded rectangles with shadows
		ctx.fillStyle = this.backgroundColor || "rgba(255, 255, 255, 0)"; // Ensure the background is transparent
		ctx.shadowColor = "rgba(0,0,0,.1)";
		ctx.shadowBlur = 6;
		ctx.shadowOffsetX = 4;
		ctx.shadowOffsetY = 4;

		ctx.drawRoundedRect(this.x, this.y, this.width / 2 - gap / 2, this.height, this.radius);
		ctx.fill();
		ctx.drawRoundedRect(this.x + this.width / 2 + gap/2, this.y, this.width / 2 - gap / 2, this.height, this.radius);
		ctx.fill();

		ctx.shadowBlur = 0;
		ctx.shadowOffsetX = 0;
		ctx.shadowOffsetY = 0;

		// preview the image before adding it to the canvas
		//document.getElementById('tempImage').src = tempCanvas.toDataURL();

		// draw left side of the icon
		ctx.drawImage(tempCanvas,
			0,
			0,
			this.shoepals_icon.width/2+border,
			this.shoepals_icon.height+border,
			this.x + this.width/2 - gap/2 - this.iconWidth/2-border,
			this.y - this.iconHeight*0.15, this.iconHeight/2+border,
			this.iconHeight+border
		);

		// draw right side of the icon
		ctx.drawImage(tempCanvas,
			this.shoepals_icon.width/2+border,
			0,
			this.shoepals_icon.width/2+border,
			this.shoepals_icon.height+border,
			this.x + this.width/2 + gap/2,
			this.y - this.iconHeight*0.15, this.iconHeight/2+border,
			this.iconHeight+border
		);
	}

	/**
	 * The two ShoePal labels (canvas px) at the true die shape. Icon ShoePals put one
	 * label on each shoe (`gap` is the distance between them); solid pairs sit side
	 * by side, the printed gap apart, scaled to the Area width. Both stay centred
	 * vertically on the Area.
	 */
	/** The spec for this Area: icon ShoePals use the label body as the die, their own TextBBs and per-set cuts. */
	shoePalGeometry(sp) {
		if (this.size !== 'shoepals_icon' || !sp.icon) {
			return sp;
		}
		return {
			...sp,
			die: { ...sp.die, ...sp.icon.body },
			left: { ...sp.left, ...sp.icon.left },
			right: { ...sp.right, ...sp.icon.right },
			iconSets: sp.icon.sets,
		};
	}

	/** Trace one ShoePal label's die: its CutContour outline (fractions of the label body), else a rounded rectangle. */
	traceShoePalDie(ctx, sp, rect, outline) {
		ctx.beginPath();
		if (!outline) {
			const radius = sp.die.radius / sp.die.w * rect.width;
			if (ctx.roundRect) {
				ctx.roundRect(rect.x, rect.y, rect.width, rect.height, radius);
			} else {
				ctx.rect(rect.x, rect.y, rect.width, rect.height);
			}
			return;
		}
		const px = (x) => rect.x + x * rect.width;
		const py = (y) => rect.y + y * rect.height;
		for (const [command, ...n] of outline) {
			if (command === 'M') {
				ctx.moveTo(px(n[0]), py(n[1]));
			} else if (command === 'L') {
				ctx.lineTo(px(n[0]), py(n[1]));
			} else {
				ctx.bezierCurveTo(px(n[0]), py(n[1]), px(n[2]), py(n[3]), px(n[4]), py(n[5]));
			}
		}
		ctx.closePath();
	}

	shoePalRects(sp) {
		const aspect = sp.die.h / sp.die.w;
		const width = this.size === 'shoepals_icon'
			? (this.width - this.gap) / 2
			: this.width * sp.die.w / (2 * sp.die.w + sp.gap);
		const height = width * aspect;
		const y = this.y + (this.height - height) / 2;
		return [
			{ x: this.x, y, width, height },
			{ x: this.x + this.width - width, y, width, height },
		];
	}

	/**
	 * Icon ShoePals: each label cut to its icon set's own die (body plus the raised
	 * tab), then the icon split across the pair, each part against its inner edge.
	 */
	drawShoePalPrint(ctx, sp, rects) {
		const fit = window.LabelTextFit;
		// The print script opens templates/Shoepallabels/<IconSet>.ai, which carries that set's cut and icon.
		const sets = sp.iconSets || {};
		const setKey = (this.printSetNames || []).map(fit.setKey).find((key) => key && sets[key]);
		const set = sets[setKey] || sets.default || { left: { iconBox: sp.left.iconBox }, right: { iconBox: sp.right.iconBox } };
		const sides = [set.left, set.right];

		ctx.save();
		ctx.fillStyle = this.backgroundColor || 'rgba(255, 255, 255, 0)';
		ctx.shadowColor = 'rgba(0,0,0,.1)';
		ctx.shadowBlur = 6;
		ctx.shadowOffsetX = 4;
		ctx.shadowOffsetY = 4;
		for (const [i, rect] of rects.entries()) {
			this.traceShoePalDie(ctx, sp, rect, sides[i].outline);
			ctx.fill();
		}
		ctx.restore();

		const img = this.shoepals_icon;
		if (!(img instanceof HTMLImageElement) || !img.complete || !img.naturalWidth) {
			return;
		}
		const ink = fit.imageInkBounds(img) || { x: 0, y: 0, width: img.naturalWidth, height: img.naturalHeight };
		const left = fit.boxFromSpec(set.left.iconBox, rects[0]);
		const right = fit.boxFromSpec(set.right.iconBox, rects[1]);
		// Contain-fit the whole icon into the two parts joined (no gap), then split it where print does.
		const boxTop = Math.min(left.y, right.y);
		const boxHeight = Math.max(left.y + left.height, right.y + right.height) - boxTop;
		const leftWidth = ink.width * left.width / (left.width + right.width);
		const fitted = Math.min((left.width + right.width) / ink.width, boxHeight / ink.height);
		const bottom = boxTop + (boxHeight + ink.height * fitted) / 2;
		const place = (scale) => ({
			top: bottom - ink.height * scale,
			parts: [
				{ sourceX: ink.x, sourceWidth: leftWidth, x: left.x + left.width - leftWidth * scale },
				{ sourceX: ink.x + leftWidth, sourceWidth: ink.width - leftWidth, x: right.x },
			],
		});
		// Print art is drawn to sit inside its die. Store icons can differ a little from
		// it, so shrink (inner edges and bottom fixed) until the die no longer cuts into
		// the icon. Art placed beyond its die is full-bleed and is left alone.
		let scale = fitted;
		const dieTop = Math.min(0, ...sides.flatMap((side) => (side.outline || []).map((command) => command[command.length - 1])));
		const iconTop = Math.min(set.left.iconBox.y0, set.right.iconBox.y0);
		const iconBottom = Math.max(set.left.iconBox.y1, set.right.iconBox.y1);
		const bleeds = iconTop < dieTop - 0.01 || iconBottom > 1;
		if (sides[0].outline && sides[1].outline && !bleeds) {
			const points = fit.imageInkEdgePoints(img);
			const cut = (candidate) => {
				const { top, parts } = place(candidate);
				let outside = 0;
				for (const [i, part] of parts.entries()) {
					const rect = rects[i];
					this.traceShoePalDie(ctx, sp, rect, sides[i].outline);
					for (const point of points) {
						const inPart = point.x >= part.sourceX && point.x < part.sourceX + part.sourceWidth;
						const x = part.x + (point.x - part.sourceX) * candidate;
						if (!inPart || x < rect.x || x > rect.x + rect.width) {
							continue;
						}
						if (!ctx.isPointInPath(x, top + (point.y - ink.y) * candidate)) {
							outside++;
						}
					}
				}
				return outside > points.length * SHOEPAL_CUT_TOLERANCE;
			};
			for (let step = 0; step < SHOEPAL_FIT_STEPS && cut(scale); step++) {
				scale *= 0.99;
			}
		}
		const { top, parts } = place(scale);
		for (const [i, part] of parts.entries()) {
			// Print art bleeds past the label's inner edge; the die trims it.
			ctx.save();
			this.traceShoePalDie(ctx, sp, rects[i], sides[i].outline);
			ctx.clip();
			ctx.drawImage(img, part.sourceX, ink.y, part.sourceWidth, ink.height, part.x, top, part.sourceWidth * scale, ink.height * scale);
			ctx.restore();
		}
	}

	/** Solid ShoePals: map each label body of the pair artwork onto its die-shaped label. */
	drawShoePalArtPrint(ctx, sp, rects) {
		const img = this.backgroundImage;
		const bodies = window.LabelTextFit.shoePalArtBodies(img);
		if (!bodies) {
			drawImageSafe(ctx, img, this.x, this.y, this.width, this.height);
			return;
		}
		const half = img.naturalWidth / 2;
		for (const [i, rect] of rects.entries()) {
			const body = bodies[i];
			const sourceX = i === 0 ? 0 : half;
			const scaleX = rect.width / body.width;
			const scaleY = rect.height / body.height;
			ctx.drawImage(
				img,
				sourceX, 0, half, img.naturalHeight,
				rect.x - (body.x - sourceX) * scaleX,
				rect.y - body.y * scaleY,
				half * scaleX,
				img.naturalHeight * scaleY
			);
		}
	}

	/** ShoePal names: fitted like print into each label's TextBB, rotated along the outer edge. */
	drawShoePalTextPrint(ctx, texts, label, sp, rects) {
		const fit = window.LabelTextFit;
		const lines = this.collectLines(texts, label);
		const product = (sp.combos && sp.combos[this.printProductCode]) || this.printProductCode;
		const leading = fit.leadingFor(window.LabelPrintSpec, this.fontName, product);
		const ink = fit.layoutInk(fit.measureLines(ctx, this.fontFamily, lines), leading);
		window.__labelFits = window.__labelFits || {};
		for (const [i, side] of [sp.left, sp.right].entries()) {
			const box = fit.boxFromSpec(side.textBox, rects[i]);
			const pxPerPt = rects[i].width / sp.die.w / 72;
			// In the rotated frame the text runs along the box's long side.
			const local = { x: -box.height / 2, y: -box.width / 2, width: box.height, height: box.width };
			const fontSize = fit.fitScale(ink, local, fit.capsFor(window.LabelPrintSpec, this.fontName, pxPerPt));
			if (!(fontSize > 0)) {
				continue;
			}
			// Print moves the ink onto the TextBB centre (both axes), then resizes around the frame.
			const drift = fit.resizeDrift(ink, fit.measureFont(ctx, this.fontFamily), leading, lines.length, sp.frameSize * pxPerPt, fontSize);
			const inkCentreX = fontSize * (ink.right - ink.left) / 2;
			const placed = fit.shiftPlaced(fit.placeBlock(ink, fontSize, local, -inkCentreX), drift.dx, drift.dy);
			ctx.save();
			ctx.translate(box.x + box.width / 2, box.y + box.height / 2);
			ctx.rotate(side.rotate * Math.PI / 180);
			ctx.font = `${fontSize}px ${this.fontFamily}`;
			ctx.textAlign = 'center';
			ctx.textBaseline = 'alphabetic';
			ctx.fillStyle = this.textColor;
			for (const [j, line] of lines.entries()) {
				ctx.fillText(line, placed.x, placed.baselines[j]);
			}
			ctx.restore();
			window.__labelFits[`${this.size}:${this.index}:${i === 0 ? 'L' : 'R'}`] = {
				size: this.size,
				index: this.index,
				lines,
				fontName: this.fontName,
				fontSizePx: fontSize,
				fontSizePt: fontSize / pxPerPt,
				leading,
				box,
				label: rects[i],
			};
		}
	}

	drawPhoto(ctx, photo) {
		let spacer = (this.width - this.iconWidth)/2;
		let radius = this.radius;
		let x = this.x + spacer;
		let y = this.y + (this.photoWellTop ?? spacer);
		let width = this.width - spacer*2;
		let height = this.width - spacer*2;

		ctx.save();

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.arcTo(x + width, y, x + width, y + height, radius);
		ctx.arcTo(x + width, y + height, x, y + height, radius);
		ctx.arcTo(x, y + height, x, y, radius);
		ctx.arcTo(x, y, x + width, y, radius);
		ctx.strokeStyle = 'black';
		ctx.lineWidth = 3;
		ctx.setLineDash([15]);
		ctx.stroke();
		ctx.closePath();
		ctx.clip();

		ctx.restore();

		if (photo.upload) {
			let img = new Image();
			img.src = photo.upload;
			img.onload = () => {
				let imgCrop = img.width;
				if (img.height < img.width ) {
					imgCrop = img.height;
				}
				imgCrop = imgCrop * (100-photo.z)/100;
				let sx = photo.x/100 * imgCrop;
				let sy = photo.y/100 * imgCrop;
				let sw = imgCrop
				let sh = imgCrop;
				let dx = this.x + spacer;
				let dy = this.y + (this.photoWellTop ?? spacer);
				let dw = this.iconWidth;
				let dh = this.iconWidth;

				photoCanvas.width = imgCrop;
				photoCanvas.height = imgCrop;
				photoCtx.drawImage(img, sx, sy, sw, sh, 0, 0, imgCrop, imgCrop);

				ctx.save();

				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				ctx.arcTo(x + width, y, x + width, y + height, radius);
				ctx.arcTo(x + width, y + height, x, y + height, radius);
				ctx.arcTo(x, y + height, x, y, radius);
				ctx.arcTo(x, y, x + width, y, radius);
				ctx.strokeStyle = 'black';
				ctx.lineWidth = 3;
				ctx.setLineDash([15]);
				ctx.stroke();
				ctx.closePath();

				ctx.clip();
				ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);

				ctx.restore();
			}
		}

		//ctx.restore();
	}
	
	drawPhoto2(ctx, photo) {
		let spacer = (this.height - this.iconHeight)/2;
		let radius = this.radius;
		let x = this.x + spacer;
		let y = this.y + spacer;
		let width = this.iconWidth;
		let height = this.iconHeight;
		
		ctx.save();
		
		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.arcTo(x + width, y, x + width, y + height, radius);
		ctx.arcTo(x + width, y + height, x, y + height, radius);
		ctx.arcTo(x, y + height, x, y, radius);
		ctx.arcTo(x, y, x + width, y, radius);
		ctx.strokeStyle = 'black';
		ctx.lineWidth = 3;
		ctx.setLineDash([15]);
		ctx.stroke();
		ctx.closePath();
		ctx.clip();
		
		ctx.restore();
		
		if (photo.upload) {
			let img = new Image();
			img.src = photo.upload;
			img.onload = () => {
				let imgCrop = img.width;
				if (img.height < img.width ) {
					imgCrop = img.height;
				}
				imgCrop = imgCrop * (100-photo.z)/100;
				let sx = photo.x/100 * imgCrop;
				let sy = photo.y/100 * imgCrop;
				let sw = imgCrop
				let sh = imgCrop;
				let dx = this.x + spacer;
				let dy = this.y + spacer;
				let dw = this.iconWidth;
				let dh = this.iconWidth;
				
				photoCanvas.width = imgCrop;
				photoCanvas.height = imgCrop;
				photoCtx.drawImage(img, sx, sy, sw, sh, 0, 0, imgCrop, imgCrop);
				
				ctx.save();
				
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				ctx.arcTo(x + width, y, x + width, y + height, radius);
				ctx.arcTo(x + width, y + height, x, y + height, radius);
				ctx.arcTo(x, y + height, x, y, radius);
				ctx.arcTo(x, y, x + width, y, radius);
				ctx.strokeStyle = 'black';
				ctx.lineWidth = 3;
				ctx.setLineDash([15]);
				ctx.stroke();
				ctx.closePath();
				
				ctx.clip();
				ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
				
				ctx.restore();
			}
		}
		
		//ctx.restore();
	}
	
	drawPhoto3(ctx, photo) {
		//let spacer = (this.height - this.iconHeight)/2;
		let spacer = 0;
		let radius = this.radius;
		let x = this.iconX;
		let y = this.iconY;
		let width = this.iconWidth;
		let height = this.iconHeight;
		
		ctx.save();
		
		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.arcTo(x + width, y, x + width, y + height, radius);
		ctx.arcTo(x + width, y + height, x, y + height, radius);
		ctx.arcTo(x, y + height, x, y, radius);
		ctx.arcTo(x, y, x + width, y, radius);
		ctx.strokeStyle = 'black';
		ctx.lineWidth = 3;
		ctx.setLineDash([15]);
		ctx.stroke();
		ctx.closePath();
		ctx.clip();
		
		ctx.restore();
		
		if (photo.upload) {
			let img = new Image();
			img.src = photo.upload;
			img.onload = () => {
				let imgCrop = img.width;
				if (img.height < img.width ) {
					imgCrop = img.height;
				}
				imgCrop = imgCrop * (100-photo.z)/100;
				let sx = photo.x/100 * imgCrop;
				let sy = photo.y/100 * imgCrop;
				let sw = imgCrop
				let sh = imgCrop;
				let dx = this.x + spacer;
				let dy = this.y + spacer;
				let dw = this.iconWidth * 2;
				let dh = this.iconHeight * 2;
				
				photoCanvas.width = imgCrop;
				photoCanvas.height = imgCrop;
				photoCtx.drawImage(img, sx, sy, sw, sh, 0, 0, imgCrop, imgCrop);
				
				ctx.save();
				
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				ctx.arcTo(x + width, y, x + width, y + height, radius);
				ctx.arcTo(x + width, y + height, x, y + height, radius);
				ctx.arcTo(x, y + height, x, y, radius);
				ctx.arcTo(x, y, x + width, y, radius);
				ctx.strokeStyle = 'black';
				ctx.lineWidth = 3;
				ctx.setLineDash([15]);
				ctx.stroke();
				ctx.closePath();
				
				ctx.clip();
				ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
				
				ctx.restore();
			}
		}
		
		//ctx.restore();
	}

	addBlur(ctx) {
		ctx.shadowBlur = 7;
		if (this.textColor === '#ffffff') {
			ctx.shadowColor = 'rgba(0, 0, 0, .8)';
		} else {
			ctx.shadowColor = 'rgba(255, 255, 255, .3)';
		}
		ctx.shadowOffsetX = 3;
		ctx.shadowOffsetY = 1;
	}

	removeBlur(ctx) {
		ctx.shadowBlur = 0;
		ctx.shadowColor = 'rgba(0, 0, 0, 0)';
	}

	calculateOptimalFontSize(ctx, text, maxWidth, maxHeight) {
		let fontSize = 1;
		let width,
			height;

		do {
			fontSize += 1;
			ctx.font = `${fontSize}px ${this.fontFamily}`;
			width = ctx.measureText(text).width;
			height = fontSize * 1.45; // 1.45 is an arbitrary value that works well for the font sizes we use
		} while (width < maxWidth && height < maxHeight);

		return fontSize - 1;
	}
}

class TagPalsArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 460,
			height= 405,
			maxTextWidth = 395,
			maxTextHeight = 180;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 77*zoom, maxTextWidth, maxTextHeight, type); // die corner 0.142 in × 539 px/in, scaled with the area
		this.iconPosition = 'top';
		this.size = 'tagPals';

		// duo tone split overwrites
		this.duoAngle = 105;
		this.duoSplit = 38; // percent
		this.duoSplitWidth = 6; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class MiniTagPalsArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		// Physical size 0.8in x 0.3in at 480px/in (same scale as mini rectangle: 2in x 0.25in = 960x120)
		let width = 384,
			height= 144,
			maxTextWidth = 320,
			maxTextHeight = 110;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 22*zoom, maxTextWidth, maxTextHeight, type);
		this.iconPosition = 'top';
		this.size = 'miniTagPals';

		// duo tone split overwrites
		this.duoAngle = 105;
		this.duoSplit = 38; // percent
		this.duoSplitWidth = 6; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class PhotoLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 448,
			height= 570, // 448 / (1.441 / 1.834)
			maxTextWidth = 380,
			maxTextHeight = 120;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		// Photo well from templates/photoRect.ai (whiteRects): a 1.181 in square,
		// 0.09 of the width from each side and 0.08 of the height from the top.
		let spacer = Math.round(width * 0.09);
		super(x, y, width, height, 48*zoom, maxTextWidth, maxTextHeight, type); // die corner 0.155 in × 311 px/in, scaled with the area
		this.hasIcon = true;
		this.iconPosition = 'top';
		this.iconWidth = width - spacer*2;
		this.iconHeight = width - spacer*2;
		this.photoWellTop = Math.round(height * 0.08);
		this.size = 'photo';
	}
}

class CircleLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 450,
			height= 450,
			maxTextWidth = 315,
			maxTextHeight = 180;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 500, maxTextWidth, maxTextHeight, type);
		this.iconPosition = 'top';
		this.size = 'circle';

		// duo tone split overwrites
		this.duoAngle = 105;
		this.duoSplit = 35; // percent
		this.duoSplitWidth = 6; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class HexagonLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 448,
			height= 392, // 448 / (1.219 / 1.066)
			maxTextWidth = 360,
			maxTextHeight = 180;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 0, maxTextWidth, maxTextHeight, type);
		this.iconPosition = 'top';
		this.size = 'hexagon';
	}
}

class RectangleLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 840,
			height= 210,
			maxTextWidth = 760,
			maxTextHeight = 140;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 39*zoom, maxTextWidth, maxTextHeight, type); // die corner 0.139 in × 280 px/in
		this.size = 'large';

		// duo tone split overwrites
		this.duoAngle = -20;
		this.duoSplit = 19; // percent
		this.duoSplitWidth = 3; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class HolidayGiftTagsLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 500, 850, 16, 430, 130, type); // 500 / (1.214 / 2.065); die corner 0.040 in × 412 px/in
		this.size = 'holidaygifttags';
		this.textY += 310;
	}
}
class AllergyLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 840, 210, 39, 640, 140, type); // same die as large: corner 0.139 in × 280 px/in
		this.iconWidth = this.height; //same as height to make it square
		this.iconHeight = this.height;
		this.iconX = this.x + this.width/2 - this.iconWidth/2;
		this.iconY = this.y + (this.height - this.iconHeight)/2;
		this.size = 'large';
		this.printSpecSize = 'allergy';
	}
}

class ShoeLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 814,
			height= 415,
			maxTextWidth = 310,
			maxTextHeight = 120;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 15, maxTextWidth, maxTextHeight, type);
		this.textX = y + this.maxTextWidth/2 + (this.height - this.maxTextWidth)/2;
		this.textY = 2000 - x - this.maxTextHeight - this.maxTextWidth/5;
		this.textMX = 2000 - y - this.height + this.maxTextHeight/2;
		this.textMY = x + this.width - this.maxTextWidth/2;
		this.size = 'shoepals';
	}
}

class ShoeLabelArea2 extends BaseArea {
	constructor(x, y, width = 1350, height= 415, gap= 550, zoom=1, type) {
		let maxTextWidth = 310,
			maxTextHeight = 140,
			iconWidth = 495,
			iconHeight = 495;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 50, maxTextWidth, maxTextHeight, type);
		this.textX = y + this.maxTextWidth/2 + (this.height - this.maxTextWidth)/2;
		this.textY = 2000 - x - this.maxTextHeight - this.maxTextWidth/5;
		this.textMX = 2000 - y - this.height + this.maxTextHeight/2;
		this.textMY = x + this.width - this.maxTextWidth/2;
		this.iconWidth = iconWidth*zoom;
		this.iconHeight = iconHeight*zoom;
		this.gap = gap;
		this.size = 'shoepals_icon';
	}
}

class MediumRectangleLabelArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 840,
			height= 298, // 840 / (1.4875 / 0.527) — true die aspect
			maxTextWidth = 725,
			maxTextHeight = 182;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 38*zoom, maxTextWidth, maxTextHeight, type); // die corner 0.067 in × 565 px/in, scaled with the area
		this.size = 'medium';

		// duo tone split overwrites
		this.duoAngle = -12;
		this.duoSplit = 22; // percent
		this.duoSplitWidth = 3; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class MiniRectangleLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 960, 159, 19, 700, 90, type); // 960 / (2.087 / 0.345) — true die aspect; die corner 0.042 in × 460 px/in
		this.iconPosition = 'left';
		this.iconWidth = 100;
		this.iconHeight = 89;
		this.iconY = this.iconY + 30; // Fix for the Y position for the icons of the mini labels
		this.size = 'mini';

		// duo tone split overwrites
		this.duoAngle = -18;
		this.duoSplit = 12; // percent
		this.duoSplitWidth = 2; // percent
		this.duoSplitColor = "#ffffff";
	}
}

class OrbitLabelArea extends BaseArea {
	constructor(x, y, type) {
		super(x, y, 830, 310, 0, 730, 180, type);
		this.iconWidth = 150;
		this.iconHeight = 150;
		this.size = 'orbit';
	}
}

class RectangleBagTagArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 1224,
			height= 1723,
			maxTextWidth = 710,
			maxTextHeight = 350;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 0, maxTextWidth, maxTextHeight, type);
		this.textY = 380;
		this.textBackY = 1700;
		this.maxTextHeightBack = 150;
		this.size = 'rectangleBagTags';
		this.iconPosition = null;
	}
}

class CircleBagTagArea extends BaseArea {
	constructor(x, y, zoom=1, type) {
		let width = 1719,
			height= 1378,
			maxTextWidth = 780,
			maxTextHeight = 320;
		width = zoom*width;
		height = zoom*height;
		maxTextWidth = zoom*maxTextWidth;
		maxTextHeight = zoom*maxTextHeight;
		super(x, y, width, height, 10, maxTextWidth, maxTextHeight, type);
		this.textY = y+height/2;
		this.size = 'circleBagTags';
		this.iconX = 425;
		this.iconY = 675;
		this.iconWidth = 450;
		this.iconHeight = 450;
		this.iconPosition = null;
	}
}

const labelAreas = {
	tagPals: [
		new TagPalsArea(112, 40),
		new TagPalsArea(112, 545),
		new TagPalsArea(112, 1049),
		new TagPalsArea(112, 1554),
		new TagPalsArea(1152, 751)
	],
	miniTagPals: [
		new MiniTagPalsArea(112, 110),
		new MiniTagPalsArea(112, 615),
		new MiniTagPalsArea(112, 1119),
		new MiniTagPalsArea(112, 1624),
		new MiniTagPalsArea(1183, 885)
	],
	circle: [
		new CircleLabelArea(520, 1102),
		new CircleLabelArea(1294, 28),
		new CircleLabelArea(1294, 523),
		new CircleLabelArea(1294, 1031),
		new CircleLabelArea(1294, 1526),
	],
	hexagon: [
		new HexagonLabelArea(360, 1031),
		new HexagonLabelArea(1350, 200),
		new HexagonLabelArea(960, 523),
		new HexagonLabelArea(1350, 1031),
		new HexagonLabelArea(960, 1326),
	],
	large: [
		new RectangleLabelArea(590, 380),
		new RectangleLabelArea(140, 1225),
		new RectangleLabelArea(1037, 1225),
		new RectangleLabelArea(140, 1555),
		new RectangleLabelArea(1037, 1555),
	],
	holidaygifttags: [
		new HolidayGiftTagsLabelArea(220, 255),
		new HolidayGiftTagsLabelArea(1020, 255),
		new HolidayGiftTagsLabelArea(620, 1120),
		new HolidayGiftTagsLabelArea(1420, 1120),
	],
	allergy: [
		new AllergyLabelArea(590, 380),
		new AllergyLabelArea(140, 1225),
		new AllergyLabelArea(1037, 1225),
		new AllergyLabelArea(140, 1555),
		new AllergyLabelArea(1037, 1555),
	],
	medium: [
		new MediumRectangleLabelArea(104, 121),
		new MediumRectangleLabelArea(1081, 121),
		new MediumRectangleLabelArea(104, 588),
		new MediumRectangleLabelArea(1076, 588),
		new MediumRectangleLabelArea(175, 1175),
	],
	mini: [
		new MiniRectangleLabelArea(377, 165),
		new MiniRectangleLabelArea(1025, 528),
		new MiniRectangleLabelArea(266, 895),
		new MiniRectangleLabelArea(1000, 1285),
		new MiniRectangleLabelArea(50, 1681),
	],
	orbit: [
		new OrbitLabelArea(594, 1246),
		new OrbitLabelArea(597, 896),
	],
	rectangleBagTags: [
		new RectangleBagTagArea(382, 139)
	],
	circleBagTags: [
		new CircleBagTagArea(160, 406)
	],
	shoepals: [
		new ShoeLabelArea(139,142),
		new ShoeLabelArea(1101,138),
		new ShoeLabelArea(139,681),
		new ShoeLabelArea(1101,681),
		new ShoeLabelArea(139, 1214),
	],
	shoepals_icon: [
		//x,y,width,height,gap, zoom
		new ShoeLabelArea2(400,1050, 1650, 428, 600, .75),
	],
	// Combo boards: every label on a board shares one px-per-inch so sizes stay in
	// true proportion. The circle bag tag (disc = 0.588 of its Area width, a 2 in
	// tag) is the reference; the other Areas are zoomed to its scale and re-centred
	// on their previous slot. Values from the research doc §8.
	M_C_CBT: [
		new CircleBagTagArea(285, 183, .69, 'bagtag'),
		new CircleLabelArea(304, 1179, 0.891,'solid'),
		new MediumRectangleLabelArea(1201, 1335, 0.618,'solid')
	],
	M_C_TP_CBT: [
		new CircleBagTagArea(117, 114, .69, 'bagtag'),
		new CircleLabelArea(1432, 208, 0.891,'solid'),
		new MediumRectangleLabelArea(330, 1340, 0.618,'solid'),
		new TagPalsArea(1464, 1254, 0.647,'solid')

	],
	M_C_L_TP_CBT: [
		new CircleBagTagArea(763, 97, .7, 'bagtag'),
		new TagPalsArea(245, 178, 0.656,'solid'),
		new CircleLabelArea(191, 780, 0.904,'solid'),
		new MediumRectangleLabelArea(166, 1447, 0.626,'solid'),
		new RectangleLabelArea(868, 1244, 1.265,'solid')

	],
	M_C_TP_CBT_SP: [
		new CircleBagTagArea(62, 118, .69, 'bagtag'),
		new CircleLabelArea(1414, 53, 0.891,'solid'),
		new MediumRectangleLabelArea(1345, 744, 0.618,'solid'),
		new TagPalsArea(1467, 1287, 0.647,'solid'),
		new ShoeLabelArea(140,1355, 0.775,'shoepals')
	],
	M_C_CBT_icon: [
		new CircleBagTagArea(285, 183, .69, 'bagtag'),
		new CircleLabelArea(304, 1179, 0.891,'icon'),
		new MediumRectangleLabelArea(1201, 1335, 0.618,'icon')
	],
	M_C_TP_CBT_icon: [
		new CircleBagTagArea(117, 114, .69, 'bagtag'),
		new CircleLabelArea(1432, 208, 0.891,'icon'),
		new MediumRectangleLabelArea(330, 1340, 0.618,'icon'),
		new TagPalsArea(1464, 1254, 0.647,'icon')

	],
	M_C_CBT_graphics: [
		new CircleBagTagArea(285, 183, .69, 'bagtag'),
		new CircleLabelArea(304, 1179, 0.891,'graphics'),
		new MediumRectangleLabelArea(1201, 1335, 0.618,'graphics')
	],
	M_C_TP_CBT_graphics: [
		new CircleBagTagArea(117, 114, .69, 'bagtag'),
		new CircleLabelArea(1432, 208, 0.891,'graphics'),
		new MediumRectangleLabelArea(330, 1340, 0.618,'graphics'),
		new TagPalsArea(1464, 1254, 0.647,'graphics')

	],
	M_C_TP_CBT_SP_icon: [
		new CircleBagTagArea(62, 118, .69, 'bagtag'),
		new CircleLabelArea(1414, 53, 0.891,'icon'),
		new MediumRectangleLabelArea(1345, 744, 0.618,'icon'),
		new TagPalsArea(1467, 1287, 0.647,'icon'),
		new ShoeLabelArea2(82,1370, 900, 428, 37, 0.7013, 'shoepals_icon')
	],
	M_C_TP_CBT_SP_graphics: [
		new CircleBagTagArea(62, 118, .69, 'bagtag'),
		new CircleLabelArea(1414, 53, 0.891,'graphics'),
		new MediumRectangleLabelArea(1345, 744, 0.618,'graphics'),
		new TagPalsArea(1467, 1287, 0.647,'graphics'),
		new ShoeLabelArea2(82,1370, 900, 428, 37, 0.7013, 'shoepals_icon')
	],
	photo: [
		new PhotoLabelArea(112, 40),
		new PhotoLabelArea(112, 670),
		new PhotoLabelArea(112, 1300),
		new PhotoLabelArea(1152, 954),
		new PhotoLabelArea(1152, 251)
	],
}

function hexToRgb(hex) {

	// Remove the "#" character if present
	hex = hex.replace("#", "");

	// Convert the hex value to RGB
	const bigint = parseInt(hex, 16);
	const r = (bigint >> 16) & 255;
	const g = (bigint >> 8) & 255;
	const b = bigint & 255;

	return { r, g, b };
}

window.addEventListener('scroll', function() {
	const customizer = document.querySelector('.customizer');
	const divBeforeNav = document.querySelector('#announcement-bar-announcement-bar');
	const stickyCanvas = document.querySelector('.sticky-canvas');
	const customizerApp = document.querySelector('.title');
	const canvasWrapper = document.querySelector('#vue-canvas-wrapper');
	const placeholder = document.querySelector('.vue-canvas-placeholder');

	// Exit early if required elements don't exist
	if (!divBeforeNav || !stickyCanvas || !customizer) return;

	const initialHeight = canvasWrapper ? canvasWrapper.offsetHeight : 0;

	// Check if divBeforeNav is visible within the viewport
	if (divBeforeNav.getBoundingClientRect().top >= 0) {
		stickyCanvas.classList.remove('position-sticky', 'sticky-top');
		customizer.classList.remove('stickyScrolling');
	} else {
		stickyCanvas.classList.add('position-sticky', 'sticky-top');
		customizer.classList.add('stickyScrolling');
	}

	if (customizerApp && canvasWrapper && placeholder) {
		if (customizerApp.getBoundingClientRect().top >= 0) {
			canvasWrapper.classList.remove('minipreview');
			placeholder.style.height = '0';
		} else {
			canvasWrapper.classList.add('minipreview');
			placeholder.style.height = `${initialHeight}px`;
		}
	}
});

document.addEventListener('DOMContentLoaded', function() {
	var sliderContainers = document.querySelectorAll('.customizer-option-slider');
	if (sliderContainers.length > 0) {
		sliderContainers.forEach(function(sliderContainer) {
			var slider = tns({
				container: sliderContainer,
				items: 2,
				nav: false,
				slideBy: 'page',
				controls: true,
				controlsPosition: 'top',
				controlsText:  ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
				edgePadding:0,
				gutter: 10,
				center:false,
				mouseDrag:true,
				loop:false,
				onInit: function () {
					sliderContainer.querySelectorAll('.tns-controls button').forEach(button => {
						button.type = 'button';
					});
				}
			});
		});
	}
	
	var olIconsSliderContainers = document.querySelectorAll('.customizer-ol-icons-slider');
	if (olIconsSliderContainers.length > 0) {
		olIconsSliderContainers.forEach(function(olIconsSliderContainer) {
			var olIconsSlider = tns({
				container: olIconsSliderContainer,
				items: 4,
				responsive: {
					1000: {
						items: 6
					}
				},
				nav: false,
				slideBy: 'page',
				controls: true,
				controlsPosition: 'top',
				controlsText:  ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
				edgePadding:0,
				gutter: 0,
				center:false,
				mouseDrag:true,
				loop:false,
				onInit: function () {
					olIconsSliderContainer.querySelectorAll('.tns-controls button').forEach(button => {
						button.type = 'button';
					});
				}
			});
		});
	}
	
	var smallIconsSliderContainers = document.querySelectorAll('.customizer-smallicons-slider');
	if (smallIconsSliderContainers.length > 0) {
		smallIconsSliderContainers.forEach(function(smallIconsSliderContainer) {
			var smallIconsSlider = tns({
				container: smallIconsSliderContainer,
				items: 3,
				responsive: {
					700: {
						items: 5
					}
				},
				nav: false,
				slideBy: 'page',
				controls: true,
				controlsPosition: 'top',
				controlsText:  ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
				edgePadding:0,
				gutter: 10,
				center:false,
				mouseDrag:true,
				loop:false,
				onInit: function () {
					smallIconsSliderContainer.querySelectorAll('.tns-controls button').forEach(button => {
						button.type = 'button';
					});
				}
			});
		});
	}
	
	var fontSliderContainers = document.querySelectorAll('.customizer-font-slider');
	if (fontSliderContainers.length > 0) {
		fontSliderContainers.forEach(function(fontSliderContainer) {
			var fontSlider = tns({
				container: fontSliderContainer,
				items: 3,
				nav: false,
				slideBy: 'page',
				controls: true,
				controlsPosition: 'top',
				controlsText:  ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
				edgePadding:0,
				gutter: 10,
				center:false,
				mouseDrag:true,
				loop:false,
				onInit: function () {
					fontSliderContainer.querySelectorAll('.tns-controls button').forEach(button => {
						button.type = 'button';
					});
				}
			});
		});
	}

	var colorSliderContainers = document.querySelectorAll('.customizer-color-slider');
	colorSliderContainers.forEach(function(colorSliderContainer) {
		var colorSlider = tns({
			container: colorSliderContainer,
			items: 4,
			responsive: {
				700: {
					items: 6
				}
			},
			nav: false,
			slideBy: 'page',
			controls: true,
			controlsPosition: 'top',
			controlsText: ['<i class="fa-solid fa-square-chevron-left text-info fs-3"></i>', '<i class="fa-solid fa-square-chevron-right text-info fs-3"></i>'],
			edgePadding: 0,
			gutter: 10,
			center: false,
			mouseDrag: true,
			loop: false,
			onInit: function() {
				colorSliderContainer.querySelectorAll('.tns-controls button').forEach(function(button) {
					button.type = 'button';
				});
			}
		});
	});
});

// Latest draw request per canvas context. Async image onload callbacks repaint
// from here so a slow-loading image can never overwrite the canvas with the
// stale selection/texts snapshot it captured when the load started.
var latestCanvasData = new WeakMap();

// drawImage wrapper that skips images that are missing, still loading, or
// failed to load — drawing a broken image throws and would abort the whole
// render pass, and drawing an incomplete one silently paints nothing anyway.
var drawImageSafe = function (ctx, img, x, y, width, height) {
	if (!img) return false;
	if (img instanceof HTMLImageElement && (!img.complete || !img.naturalWidth)) return false;
	ctx.drawImage(img, x, y, width, height);
	return true;
}

var repaintLatest = function (ctx, fallbackData) {
	window.updateCanvas(ctx, latestCanvasData.get(ctx) || fallbackData);
}

window.updateCanvas = function (ctx, data) {
	latestCanvasData.set(ctx, data);
	window.__labelFits = {};
	// The print-accurate fit sizes text from measured glyph metrics, so a first
	// paint made while a label webfont is still loading is visibly wrong. Repaint
	// once loading settles; status is 'loaded' afterwards, so this cannot loop.
	if (document.fonts && document.fonts.status === 'loading') {
		document.fonts.ready.then(() => repaintLatest(ctx, data));
	}
	ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
	var orbitGraphics = data.label.type == 'orbit' && data.selection.set ? data.selection.set.graphics : null;
	if (orbitGraphics && orbitGraphics.length > 1) {
		// Fall back to the single-color background while the two-color one loads
		if (!drawImageSafe(ctx, data.label.backgroundImage2, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT)) {
			drawImageSafe(ctx, data.label.backgroundImage, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
		}
	} else {
		drawImageSafe(ctx, data.label.backgroundImage, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
	}

	let $data = data;
	let colors = [];
	if (data.selection.color) {
		colors = data.selection.color.values;
	}
	let color_alts = [];
	if (data.selection.color_alt) {
		color_alts = data.selection.color_alt.values;
	}
	let orbitIconImage = null;
	if (data.label.type == 'orbit' && data.orbitIconImage && data.texts.Letter != 'x') {
		if (typeof orbitIconImages[data.orbitIconImage] == 'undefined') {
			const iconSrc = data.orbitIconImage;
			orbitIconImages[iconSrc] = new Image();
			orbitIconImages[iconSrc].setAttribute("crossorigin", "anonymous");
			orbitIconImages[iconSrc].onload = function () {
				repaintLatest(ctx, data);
			}
			orbitIconImages[iconSrc].onerror = function () {
				console.warn('[vue-canvas] Failed to load orbit icon image:', iconSrc);
				delete orbitIconImages[iconSrc];
			}
			orbitIconImages[iconSrc].src = iconSrc;
		}
		orbitIconImage = orbitIconImages[data.orbitIconImage];
	}
	//let areas = labelAreas[data.label.size];
	//let areas = labelAreas[data.label.size].map(area => cloneArea(area));
	let areas = labelAreas[data.label.size].map(area => {
		// Create a shallow copy of the area
		const newArea = Object.create(Object.getPrototypeOf(area));
		// Copy all properties
		return Object.assign(newArea, area);
	});


	let labelTypeIndex = 0;
	let currentLabelType = null;
	let i = 0;
	// The print product (AL SCRIPT template folder) behind this canvas: the variant's
	// customizer.product_code, passed by the customizer and the personalized grid.
	const printProductCode = data.productCode || (data.label && data.label.productCode) || null;
	// The template file within that product: icon set name, else colour name (solids).
	const printSetNames = [
		data.selection && data.selection.set && data.selection.set.name,
		data.selection && data.selection.color && data.selection.color.name,
	];

	areas.forEach((area, j) => {
		if (data.label.type == 'orbit' && (!data.selection.set || data.selection.set.graphics.length < j+1)) {
			return;
		}
		if (area.size != currentLabelType) {
			labelTypeIndex = 0;
			currentLabelType = area.size;
		}
		if (data.label.type != 'combo') {
			area.type = data.label.type;
		}
		i = labelTypeIndex
		area.index = i;
		area.printProductCode = printProductCode;
		area.printSetNames = printSetNames;
		area.printTemplate = window.LabelTextFit
			? window.LabelTextFit.resolveTemplate(window.LabelPrintSpec, printProductCode, area.printSpecSize || area.size, printSetNames)
			: null;
		if (area.type == 'icon') {
			area.backgroundColor = '#ffffff';
		}
		if (['icon', 'monogram', 'orbit'].indexOf(area.type) >= 0) {
			area.hasIcon = !(area.type == 'orbit' && data.texts.Letter == 'x');
		}
		if (area.type == 'photo' && area.size != 'photo') {
			area.hasIcon = true;
		}
		if (data.selection.set) {
			let set = data.selection.set;
			let image = null;
			if (set.graphics.length > 0 && !area.isTextColorLocked) {
				area.textColor = set.graphics[i % set.graphics.length].fontColor;
			}
			if (area.type == 'bagtag' || (area.type=='photo' && area.size != 'circleBagTag')) {
				image = set.bagTags[area.size].image;
				
					area.textColor = set.bagTags[area.size].color;
					area.textColorBack = set.bagTags[area.size].color_back;
				
				// Force the color to stay by preventing color_alt from affecting it
				area.originalTextColor = area.textColor;
				area.isTextColorLocked = true;
				
				if (set.bagTags[area.size].has_back) {
					data.label.has_back = true;
				} else {
					data.label.has_back = false;
				}
			} else {
				image = window.getGraphicImage(set.graphics[i % set.graphics.length].images, area);
			}
			if (['icon', 'graphics', 'photo', 'bagtag', 'shoepals', 'shoepals_icon', 'orbit'].indexOf(area.type) >= 0) {
				if (image) {
					let imgName = set.name + area.size + (i % set.graphics.length);
					if (typeof loadedImages[imgName] == 'undefined') {
						loadedImages[imgName] = {}
					}
					if (typeof loadedImages[imgName].img == 'undefined') {
						// crossorigin must be set before src so the fetch is a CORS
						// request — otherwise the canvas is tainted and toDataURL throws
						loadedImages[imgName].img = new Image();
						loadedImages[imgName].img.setAttribute("crossorigin", "anonymous");
						loadedImages[imgName].img.onload = function () {
							repaintLatest(ctx, data);
						}
						loadedImages[imgName].img.onerror = function () {
							console.warn('[vue-canvas] Failed to load graphic image:', image.src);
							delete loadedImages[imgName];
						}
						loadedImages[imgName].img.src = image.src;
					}
					if (['icon'].indexOf(area.type) >= 0) {
						area.iconImage = loadedImages[imgName].img;
					} else {
						if (area.type == 'shoepals_icon') {
							area.shoepals_icon = loadedImages[imgName].img;
						} else {
							area.backgroundImage = loadedImages[imgName].img;
						}
					}
				}
			}

			if (set.fontFamily) {
				area.fontFamily = set.fontFamily;
				area.fontName = set.fontName;
				area.baseline = set.baseline;
			} else {
				if (data.selection.font) {
					area.fontFamily = data.selection.font.family;
					area.fontName = data.selection.font.name;
				}
			}
			if (set.presets.colors) {
				area.backgroundColor = set.presets.colors[(i) % set.presets.colors.length];
			}
		}
		if (colors.length > 0) {
			let color = colors[(i) % colors.length];
			if (data.label.type == 'white') {
				area.backgroundColor = '#ffffff';
				area.textColor = color;
			} else {
				if (data.selection.color.textColor && area.type != 'bagtag' && data.label.type != 'orbit') {
					area.textColor = data.selection.color.textColor;
				}
				area.backgroundColor = color;
			}
		}
		if (color_alts.length > 0 && !area.isTextColorLocked) {
			let color = color_alts[(i) % color_alts.length];
			area.backgroundColorAlt = color;
			if (data.selection.color_alt.textColor && data.label.type != 'orbit') {
				area.textColor = data.selection.color_alt.textColor;
			}
		}
		// ShoePals print as a die-shaped pair; see LabelPrintSpec.shoepal.
		const shoePalSpec = ['shoepals', 'shoepals_icon'].includes(area.size) && window.LabelPrintSpec && window.LabelTextFit
			? area.shoePalGeometry(window.LabelPrintSpec.shoepal)
			: null;
		const shoePalRects = shoePalSpec ? area.shoePalRects(shoePalSpec) : null;
		if (area.backgroundImage) {
			ctx.save();
			ctx.shadowColor = "rgba(0, 0, 0, .4)";
			ctx.shadowBlur = 20;
			ctx.shadowOffsetX = 4;
			ctx.shadowOffsetY = 4;
			if (shoePalSpec && area.backgroundImage.complete && area.backgroundImage.naturalWidth) {
				area.drawShoePalArtPrint(ctx, shoePalSpec, shoePalRects);
			} else {
				drawImageSafe(ctx, area.backgroundImage, area.x, area.y, area.width, area.height);
			}
			ctx.restore();
		} else {
			if (area.shoepals_icon) {
				if (shoePalSpec) {
					area.drawShoePalPrint(ctx, shoePalSpec, shoePalRects);
				} else {
					area.drawShoePalIcon(ctx);
				}
			} else {
				area.drawBGColor(ctx);
			}
		}

		if (!area.textColor) {
			area.textColor = '#000000';
		}

		if (data.selection.font) {
			if (area.type != 'bagtag') {
				area.fontFamily = data.selection.font.family;
				area.fontName = data.selection.font.name;
				area.baseline = data.selection.font.baseline;
				area.monogram_baseline = data.selection.font.monogram_baseline;
				if (data.label.type == 'monogram') {
					area.fontFamilyMono = data.selection.font.monogram_family;
				}
			}
		}

		switch (area.type) {
			case 'shoepals':
			case 'shoepals_icon':
				if (shoePalSpec) {
					area.drawShoePalTextPrint(ctx, $data.texts, $data.label, shoePalSpec, shoePalRects);
					break;
				}
				area.mirrored = false;
				ctx.save();
				ctx.translate(1000, 1000);
				ctx.rotate(90 * Math.PI / 180);
				ctx.translate(-1000, -1000);
				area.drawText(ctx, $data.texts, $data.label);
				ctx.restore();
				area.mirrored = true;
				ctx.save();
				ctx.translate(1000, 1000);
				ctx.rotate(-90 * Math.PI / 180);
				ctx.translate(-1000, -1000);
				area.drawText(ctx, $data.texts, $data.label);
				ctx.restore();
				break;
			case 'orbit':
				area.drawTextOrbit(ctx, $data.texts, $data.label);
				area.drawOrbitIcon(ctx, orbitIconImage, data.label);
				break;
			case 'photo':
				switch (area.size) {
					case 'photo':
						area.drawPhoto(ctx, $data.photo);
						break;
					case 'circleBagTags':
						area.drawPhoto3(ctx, $data.photo);
						break;
					default:
						area.drawPhoto2(ctx, $data.photo);
				}
				area.drawText(ctx, $data.texts, $data.label);
				break;
			default:
				if (data.label.type == 'monogram') {
					area.drawLetter(ctx, data.texts.Letter, data.label);
				}
				area.drawText(ctx, $data.texts, $data.label);
		}

		if (area.iconImage) {
			if (area.iconClip) {
				// Print art is trimmed by the die-cut; the allergy panel bleeds to the edge.
				ctx.save();
				ctx.beginPath();
				if (ctx.roundRect) {
					ctx.roundRect(area.x, area.y, area.width, area.height, area.radius);
				} else {
					const r = Math.min(area.radius, area.width / 2, area.height / 2);
					ctx.moveTo(area.x + r, area.y);
					ctx.arcTo(area.x + area.width, area.y, area.x + area.width, area.y + area.height, r);
					ctx.arcTo(area.x + area.width, area.y + area.height, area.x, area.y + area.height, r);
					ctx.arcTo(area.x, area.y + area.height, area.x, area.y, r);
					ctx.arcTo(area.x, area.y, area.x + area.width, area.y, r);
					ctx.closePath();
				}
				ctx.clip();
			}
			drawImageSafe(ctx, area.iconImage, area.iconX, area.iconY, area.iconWidth, area.iconHeight);
			if (area.iconClip) {
				ctx.restore();
			}
		}

		drawImageSafe(ctx, data.label.overlayImage, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

		labelTypeIndex++;
	});
}

window.getGraphicImage = function (images, area) {
	let size = area.size;
	if (size == 'shoepals_icon') {
		size = 'shoepals';
	}
	if (area.type == 'orbit') {
		return images['large'];
	}
	if (images[size]) {
		if (images[size].src != '') {
			return images[size];
		} else {
			if (images['large'].src != '') {
				return images['large']
			} else {
				return false;
			}
		}
	}
	return  false;
}

function cloneArea(area) {
	// Store original properties before creating new instance
	const originalProps = {
		iconWidth: area.iconWidth,
		iconHeight: area.iconHeight,
		iconX: area.iconX,
		iconY: area.iconY,
		iconPosition: area.iconPosition,
		hasIcon: area.hasIcon,
		size: area.size,
		type: area.type,
		zoom: area.zoom,
		backgroundColor: area.backgroundColor,
		textColor: area.textColor,
		fontFamily: area.fontFamily,
		baseline: area.baseline,
		textX: area.textX,
		textY: area.textY,
		textMX: area.textMX,
		textMY: area.textMY,
		maxTextWidth: area.maxTextWidth,
		maxTextHeight: area.maxTextHeight,
		maxTextHeightBack: area.maxTextHeightBack,
		textBackY: area.textBackY,
		duoAngle: area.duoAngle,
		duoStart: area.duoStart,
		duoSplit: area.duoSplit,
		duoSplitWidth: area.duoSplitWidth,
		duoSplitColor: area.duoSplitColor
	};

	let newArea;

	if (area instanceof TagPalsArea) {
		newArea = new TagPalsArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof MiniTagPalsArea) {
		newArea = new MiniTagPalsArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof CircleLabelArea) {
		newArea = new CircleLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof HexagonLabelArea) {
		newArea = new HexagonLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof RectangleLabelArea) {
		newArea = new RectangleLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof HolidayGiftTagsLabelArea) {
		newArea = new HolidayGiftTagsLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof AllergyLabelArea) {
		newArea = new AllergyLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof ShoeLabelArea) {
		newArea = new ShoeLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof ShoeLabelArea2) {
		newArea = new ShoeLabelArea2(
			area.x,
			area.y,
			area.width/originalProps.zoom,
			area.height/originalProps.zoom,
			area.gap,
			originalProps.zoom,
			originalProps.type
		);
	} else if (area instanceof MediumRectangleLabelArea) {
		newArea = new MediumRectangleLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof MiniRectangleLabelArea) {
		newArea = new MiniRectangleLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof OrbitLabelArea) {
		newArea = new OrbitLabelArea(area.x, area.y, originalProps.type);
	} else if (area instanceof RectangleBagTagArea) {
		newArea = new RectangleBagTagArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof CircleBagTagArea) {
		newArea = new CircleBagTagArea(area.x, area.y, originalProps.zoom, originalProps.type);
	} else if (area instanceof PhotoLabelArea) {
		newArea = new PhotoLabelArea(area.x, area.y, originalProps.zoom, originalProps.type);
	}

	if (newArea) {
		// Restore original properties
		Object.keys(originalProps).forEach(key => {
			if (originalProps[key] !== undefined) {
				newArea[key] = originalProps[key];
			}
		});

		return newArea;
	}

	console.warn('Unknown area type:', area);
	return area;
}

} // End guard: window.__vueCanvasLoaded
